import React from 'react';

export default function EmptyState({ title, children, action, className = '' }) {
  return (
    <div className={`px-4 py-10 max-w-[60ch] ${className}`}>
      <p className="text-section text-ink">{title}</p>
      {children && <p className="mt-1 text-body text-graphite">{children}</p>}
      {action && <div className="mt-4 flex gap-2">{action}</div>}
    </div>
  );
}
